import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import {  Router, RouterModule } from '@angular/router';
import { AuthService } from 'src/app/shared/services';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        RouterModule,
        CommonModule
    ],
    selector: 'app-app-loader',
    templateUrl: './app-loader.component.html',
    styles: []
})
export class AppLoaderComponent {

  private authService = inject( AuthService );
  private router = inject( Router );

  public finishedAuthCheck = computed<boolean>( () => {
    if ( this.authService.currentUser() === null ) {
      const resp = this.authService.checkUser();
      if (resp) {
        return false;
      } else {
        this.router.navigate( [ 'auth/login' ] );
      }
       
    }
    if ( this.authService.currentUser()?.isDeleted) {
      this.router.navigate( [ 'auth/no-access' ] );
      return false;
    }
    if ( this.authService.currentUser()?.firstSession) {
      this.router.navigate( [ 'auth/alta-empleado' ] );
      return false;
    } else {
      return true;
    }
  });

}
